import axios from '@/api/axios'

const BASE_PATH = 'go/lvmmed'
const EXTERNAL_ORG_ID_STORAGE_KEY = 'hodo_lvmmed_external_org_id'

function getPayloadData (response) {
  return response?.data?.data
}

class LvmmedService {
  getExternalOrgId () {
    return window.localStorage.getItem(EXTERNAL_ORG_ID_STORAGE_KEY) || ''
  }

  saveExternalOrgId (linkData) {
    const orgId = linkData?.lvmmed_org_info?.id
    if (Number(linkData?.link_status) === 1 && orgId !== undefined && orgId !== null && orgId !== '') {
      window.localStorage.setItem(EXTERNAL_ORG_ID_STORAGE_KEY, String(orgId))
      return
    }
    window.localStorage.removeItem(EXTERNAL_ORG_ID_STORAGE_KEY)
  }

  async getLinkStatus () {
    const response = await axios.get(`${BASE_PATH}/link-status`)
    const responseBody = response?.data || {}
    const linkData = responseBody?.data
    if (!linkData || typeof linkData !== 'object' || Array.isArray(linkData)) {
      return null
    }
    this.saveExternalOrgId(linkData)
    return linkData
  }

  async unlink () {
    const response = await axios.post(`${BASE_PATH}/unlink`, {})
    window.localStorage.removeItem(EXTERNAL_ORG_ID_STORAGE_KEY)
    return getPayloadData(response)
  }

  async oauthInit ({ redirectUri } = {}) {
    const payload = {}
    if (redirectUri) payload.redirect_uri = redirectUri
    const response = await axios.post(`${BASE_PATH}/oauth/init`, payload)
    return getPayloadData(response)
  }

  async oauthCallback ({ code, state }) {
    const response = await axios.post(`${BASE_PATH}/oauth/callback`, {
      code,
      state
    })
    return getPayloadData(response)
  }
}

export default new LvmmedService()
